import StoreName     from '../../Shared/Constants/StoreName';
import IPlayerState  from '../../Shared/Interfaces/IPlayerState';

import ILocalStorage              from './Interfaces/ILocalStorage';
import ILocalStorageStore         from './Interfaces/ILocalStorageStore';
import LocalStorage               from './LocalStorage';
import resolveLocalStorageActions from './resolveLocalStorageActions';

const createLocalStorageStore = (
    state: IPlayerState,
    initialValue: ILocalStorage = {}
): ILocalStorageStore =>
    state.createStore({
        name: StoreName.LOCAL_STORAGE,
        model: LocalStorage,
        actions: resolveLocalStorageActions
    }, initialValue);

export default createLocalStorageStore;
